<div [formGroup]="companyContactFormGroup"
     fxLayout="row wrap"
     fxLayoutGap="12px grid">

    <div fxFlex="100">
        <h2 *ngIf="headline" [innerHTML]="headline"></h2>
        <h2 *ngIf="!headline" [innerHTML]="'workflows.formWidgets.companyContact.headline' | translate"></h2>

        <div class="button-group">
            <button mat-stroked-button type="button" color="accent" data-test="B-Nach Person suchen"
                    (click)="onClickAddAddress()">
                <mat-icon>playlist_add</mat-icon>
                {{ 'workflows.formWidgets.companyContact.searchPerson' | translate }}
            </button>
            <ng-container *ngIf="companyContact?.id">
                <button mat-stroked-button type="button" color="accent" data-test="B-Neue Person erfassen"
                        (click)="onClickRemovePerson()">
                    <mat-icon>add</mat-icon>
                    {{ 'workflows.companyContact.formWidget.newPerson' | translate }}
                </button>
            </ng-container>
        </div>

        <ng-container *ngIf="companyContact?.person?.id">
            <h3>
                {{ 'workflows.formWidgets.companyContact.selectedPersonPrefix' | translate }}
                <strong>{{companyContact.personName}}</strong>
                <button mat-icon-button type="button" color="warn" (click)="onClickRemovePerson()">
                    <mat-icon>cancel</mat-icon>
                </button>
            </h3>
        </ng-container>
    </div>


    <mat-form-field appearance="fill" fxFlex="100" fxFlex.gt-xs="100" floatLabel="always">
        <mat-label>{{ 'common.name' | translate }}</mat-label>
        <input matInput data-test="FI-Name" type="text" formControlName="personName" autocomplete="new-password">
        <mat-error>{{companyContactFormGroup.get('personName').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="60" floatLabel="always">
        <mat-label>{{ 'common.email' | translate }}</mat-label>
        <input matInput data-test="FI-E-Mail" type="text" formControlName="personMail" autocomplete="new-password">
        <mat-error>{{companyContactFormGroup.get('personMail').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex="40" floatLabel="always">
        <mat-label>{{ 'common.phoneNumber' | translate }}</mat-label>
        <input matInput data-test="FI-Telefonnummer" type="text" formControlName="personPhone"
               autocomplete="new-password">
        <mat-error>{{companyContactFormGroup.get('personPhone').errors | firstErrorMessage}}</mat-error>
    </mat-form-field>

</div>
